import { config } from '@carbonara/config'

export const generateUrl = (path: string) => {
	const protocol = process.env.NODE_ENV === 'production' ? 'https' : 'http'
	const url = new URL(path, `${protocol}://${config.webappHostname}`)
	return url
}
